<template>
  <div class="document">
    <dl>
      <dt>
        <img src="@/assets/mail.png" alt="">
        <p>キャンペーン特典のAmazonギフト券はメールでお送りします。<br class="pc_only ipad">受け取りに使用するメールアドレスをご登録ください。</p>
      </dt>
      <dd>
        <label for="v2f-inp_email">メールアドレス</label>
        <input type="email" id="v2f-inp_email" name="email" class="email" v-model="email_input" placeholder="メールアドレスを入力">
      </dd>
    </dl>

    <button type="button" class="form_btn" @click="submitData()">メールアドレスを登録する</button>

    <p>※URLの有効期間は14日間です</p>

    <div class="outline">
      <h2>キャンペーン内容</h2>
      <p>期間内に対象商品をご売却いただくと、買取金額に加えてAmazonギフト券*をもれなくプレゼントします。
        <br>*買取金額のお支払い日の翌月末までに、ご登録のメールアドレス宛にお送りします。</p>
    </div><!--/outline-->

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "form-btns",
  computed: {
    ...mapGetters(["ispc"]),
  },
  data() {
    return {
      email_input: this.$store.state.info.email || "",
    }
  },
  methods: {
    ...mapActions(["saveInfo"]),
    submitData() {
      this.$store.commit('update', { email: this.email_input });
      this.saveInfo(this.email_input);
    },
  },
  props: ["templateType"],
};
</script>



// WEBPACK FOOTER //
// src/components/FormBtns.vue